import { render, staticRenderFns } from "./Localisation.vue?vue&type=template&id=216c30c5&scoped=true&"
import script from "./Localisation.vue?vue&type=script&lang=ts&"
export * from "./Localisation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216c30c5",
  null
  
)

export default component.exports